import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';
import { Box, Center, VStack } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React, { ChangeEvent, DragEvent, useState } from 'react';

type FileInputWithDropzoneProps = {
  onFileChange: (file: File) => void;
  inputFileRef: React.MutableRefObject<HTMLInputElement | null>;
};

export const FileInputWithDropzone = ({ onFileChange, inputFileRef }: FileInputWithDropzoneProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);
  const handleDragLeave = (e: DragEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    setIsHovered(false);
  };

  const handleFileInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const file = e?.target?.files && e.target.files[0];
    if (file) onFileChange(file);
  };

  const handleFileInputClick = (): void => {
    if (inputFileRef && inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const onDrop = (e: DragEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    setIsHovered(false);
    const { files } = e.dataTransfer;
    const file = files && files[0];
    if (file) {
      onFileChange(file);
    }
  };

  const onDragOver = (e: DragEvent): void => {
    setIsHovered(true);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <>
      <Center
        px={3}
        py={5}
        gap={1}
        mb={1}
        alignContent="center"
        borderRadius={8}
        borderStyle="dashed"
        borderWidth={1}
        transition="all normal ease-in-out"
        _hover={{
          bg: 'background.secondaryAlpha.hover',
          borderColor: 'border.focus',
        }}
        bg={isHovered ? 'background.secondaryAlpha.hover' : undefined}
        borderColor={isHovered ? 'border.focus' : undefined}
        cursor="pointer"
        onDragLeave={handleDragLeave}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onClick={handleFileInputClick}
      >
        <VStack>
          <Icon name="upload" size="lg" />
          <Box textAlign="center">
            <Heading size="sm">Click or drag and drop</Heading>
            <Text size="sm" mt={0}>
              .CSV files only
            </Text>
          </Box>
        </VStack>
      </Center>
      <TextInput
        onChange={handleFileInputChange}
        onClick={(e): void => {
          e.currentTarget.value = '';
        }}
        ref={inputFileRef}
        display="none"
        type="file"
        accept=".csv"
      />
    </>
  );
};
